import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import InterestForm from "./InterestForm";
import InterestsTable from "./InterestsTable";
import { interestService } from "./services/interest.service";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

class ManageInterests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      pages: null,
      showModal: false,
      notResetMode: false,
      submitSucessful: false,
      showNextJoyRide:false,
      showJoyRideOnTable:false
    };
    this.resetButton = this.resetButton.bind(this);
  }

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllInterest({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getAllInterest = params => {
    this.setState({ fetching: true });
    interestService
      .getAllInterest(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  addInterest = data => {
    const { pageSize, selectedRow } = this.state;
    this.setState({
      submitting: true,
      formError: null,
      submitSucessful: false
    });
    interestService
      .addInterest(data, selectedRow && selectedRow.id)
      .then(response => {
        this.setState({
          response,
          formError: null,
          submitting: false,
          submitSucessful: true
        });
        this.getAllInterest({ pageNum: 1, pageSize });
        if (!selectedRow) {
          toast.success("Interest created successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        } else {
          toast.success("Interest updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
          this.resetButton();
        }
      })
      .catch(error => this.setState({ formError: error, submitting: false }));
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };

  deleteInterest = item => {
    if (item.id) {
      interestService
        .deleteInterest(item.id)
        .then(response => {
          this.setState({ response, error: null, submitting: false });
          this.fetchData();
          toast.success("Interest deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        })

        .catch(error => this.setState({ formError: error, submitting: false }));
    }

    this.setState({
      showModal: !this.state.showModal
    });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal
    });
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitSucessful: false
    });
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllInterest(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };
//===========================TOUR GUIDE SECTION==================//
setNextJoyRide=()=>{
  this.setState({showNextJoyRide:false})
}

startJoyRideAtDataTable=()=>{
 this.setState({showJoyRideOnTable:true})
}

stopJoyRideAtDataTable=()=>{
  this.setState({showJoyRideOnTable:false})
 }

 routeChange = () => {
  this.props.history.push({
    pathname: `/activities`,
    state: { run: true },
  });
};
  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      formError,
      hasParams,
      selectedRow,
      submitSucessful,
      showNextJoyRide,
      showJoyRideOnTable
    } = this.state;
    return (
      <div>
        <Row>
          <Col sm="4">
            <InterestForm
              submitting={submitting}
              error={formError}
              hasParams={hasParams}
              selectedRow={selectedRow}
              submitAction={this.addInterest}
              reset={this.resetButton}
              notResetMode={this.notResetMode}
              submitSucessful={submitSucessful}
              showNextJoyRide={showNextJoyRide}
              setNextJoyRide={this.setNextJoyRide}
              startJoyRideAtDataTable={this.startJoyRideAtDataTable}
            />
          </Col>
          <Col sm="8">
            <InterestsTable
              fetching={fetching}
              hasParams={hasParams}
              selectedRow={selectedRow}
              data={data}
              selectRow={this.selectRow}
              error={error}
              DeleteModal={this.DeleteModal}
              deleteInterest={this.deleteInterest}
              showModal={this.showConfirmation}
              pages={pages}
              page={pageNum}
              pageSize={pageSize}
              filterData={this.filterData}
              setPageNumber={this.setPageNumber}
              setPageSize={this.setPageSize}
              routeChange={this.routeChange}
              showJoyRideOnTable={showJoyRideOnTable}
              stopJoyRideAtDataTable={this.stopJoyRideAtDataTable}
              
            />
          </Col>
          <ConfirmationModal
            isOpen={this.state.showModal}
            showModal={this.showConfirmation}
            action={this.deleteInterest}
            item={selectedRow}
          />
        </Row>
      </div>
    );
  }
}

export default ManageInterests;
